import { getJWT, getLocal, getLocalId } from '../Utils/Profile'
import { BASEAPI } from './constants'
interface ApiResponse {
    idPromocion: number
}
const postPromotion = async (
    sLocal: string,
    data: any
): Promise<ApiResponse | null> =>
    fetch(`${BASEAPI}wsAppComercios/Promociones/store/${sLocal}`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: getJWT(),
        },
        body: JSON.stringify(data),
    })
        .then((response) => {
            return response.json()
        })
        .catch((error) => {
            console.error(error)
            alert('Hubo un error')
            return null
        })

const postProductPromotion = async (data: any): Promise<any> => {
    console.log('🚀 ~ postProductPromotion ~ data:', data)
    const commerce = localStorage.getItem('currentUser')
    const commerceData: ICommerceBO = commerce ? JSON.parse(commerce) : null
    const internalID = commerceData.sEstablecimiento + getLocal()

    fetch(`${BASEAPI}apimac/api/v1/mac/product/promotion/stock`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: getJWT(),
        },
        body: JSON.stringify({ ...data, commerceInternalID: internalID }),
    })
        .then((response) => {
            return response.json()
        })
        .catch((error) => {
            console.error(error)
            alert('Hubo un error')
            return null
        })
}

const getLastPromotionCreated = async () => {
    try {
        return await fetch(
            `${BASEAPI}amipos-back/promotion/f2f/store/${getLocal()}`,
            {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: getJWT(),
                },
            }
        ).then((response) => response.json())
    } catch (error) {
        console.error(error)
        return null
    }
}

const getAllPromotions = async (sLocal: string): Promise<ApiResponse | null> =>
    fetch(`${BASEAPI}wsAppComercios/Promociones/store/${sLocal}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: getJWT(),
        },
    })
        .then((response) => {
            return response.json()
        })
        .catch((error) => {
            console.error(error)
            return null
        })

const deletePromotion = async (
    idCommerce: string,
    sLocal: string,
    idPromotion: string
): Promise<ApiResponse | null> => {
    const currentUser = localStorage.getItem('currentUser')

    const user = currentUser && JSON.parse(currentUser)
    const token = user?.token || ''

    return fetch(
        `${BASEAPI}wsAppComercios/Promociones/store/${getLocalId()}/${idPromotion}`,
        {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
        }
    )
        .then((response) => {
            return response.json()
        })
        .catch((error) => {
            console.error(error)
            alert('Hubo un error')
            return null
        })
}

const getPromotionProduct = async (idPromotion: string): Promise<any[]> => {
    try {
        const response = await fetch(
            `${BASEAPI}apimac/api/v1/mac/product/promotion/${idPromotion}`,
            {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: getJWT(),
                },
            }
        )
        const data = await response.json()

        if (Array.isArray(data)) {
            console.log('🚀 ~ getPromotionProduct ~ data:', data)
            return data
        } else {
            return []
        }
    } catch (error) {
        console.error(error)
        alert('Hubo un error')
        return []
    }
}

const getOnePromotion = async (
    idPromocion: string
): Promise<ApiResponse | null> =>
    fetch(`${BASEAPI}apimac/api/v1/mac/product/promotion/${idPromocion}`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: getJWT(),
        },
    })
        .then((response) => {
            return response.json()
        })
        .catch((error) => {
            console.error(error)
            alert('Hubo un error')
            return null
        })

export {
    postPromotion,
    postProductPromotion,
    getLastPromotionCreated,
    getAllPromotions,
    deletePromotion,
    getPromotionProduct,
    getOnePromotion,
}
